<template>
	<div >
		<h2 class="h2">未分配案件</h2>
		<el-table :data="tableData" style="width: 100%">
			<el-table-column type="index" label="序号"></el-table-column>
			<el-table-column prop="obj.caseNo" label="案件编号"></el-table-column>
			<el-table-column label="发生地点">
				<template slot-scope="scope">
					{{ setTxt(scope.row.generalLocation.addr) }}
				</template>
			</el-table-column>
			<el-table-column prop="victimList[0].obj.victimName" label="用户姓名"></el-table-column>
			<el-table-column prop="obj.reporterContact" label="用户手机号"></el-table-column>
			<el-table-column prop="victimList[0].obj.idNo" label="证件信息">
				<template slot-scope="scope">
					{{ scope.row.victimList[0].obj.idNo || '无' }}
				</template>
			</el-table-column>
			<el-table-column label="性别">
				<template slot-scope="scope">
					{{ scope.row.victimList[0].obj.gender == 1 ? '男' : '女' }}
				</template>
			</el-table-column>
			<el-table-column prop="name" label="出险时间">
				<template slot-scope="scope">
					{{ setTime(scope.row.obj.incidentTs) }}
				</template>
			</el-table-column>
			<el-table-column label="用户保险详情">
				<template slot-scope="scope">
					<span>{{ scope.row.victimList[0].obj.insurancePolicyNo || '无' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="当前进度">
				<template slot-scope="scope">
					{{ setPt(scope.row.obj.caseState).phase }}
				</template>
			</el-table-column>
			<el-table-column label="当前节点">
				<template slot-scope="scope">
					{{ setPt(scope.row.obj.caseState).node }}
				</template>
			</el-table-column>
			<el-table-column label="到达时间">
				<template slot-scope="scope">
					{{ setTime(scope.row.obj.incidentTs) }}
				</template>
			</el-table-column>
			<el-table-column prop="name" label="操作">
				<template slot-scope="scope">
					<el-button v-if='accountLevel == 0' type="text" @click="dialogVisible = true;caseId=scope.row.obj.id">分配案件</el-button>
					<el-button v-if='accountLevel == 1' type="text" disabled>分配案件</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog title="分配案件" :visible.sync="dialogVisible" width="600px" @close="addBoss=[];subBossId=''">
			<div>
				<el-select v-model="subBossId" placeholder="请选择" @change="changeBossFun">
					<el-option v-for="item in subBoss" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<el-button type="primary" @click='addBossFun'>添加</el-button>
			</div>
			<ul class="addBoss">
				<li v-for="(item,index) in addBoss">
					<p>{{item.name}}</p>
					<i class="el-icon-remove-outline" @click="deleteObj(index)"></i>
				</li>
			</ul>
			<span slot="footer" class="dialog-footer" >
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitBoss()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { listUnassignedCase,listSubUser,assignSubRegulator } from '@/views/axios/api.js';
import constants from '@/util/constants.js';
export default {
	data() {
		return {
			msg: '',
			tableData: [],
			dialogVisible: false,
			token:JSON.parse(window.localStorage.getItem('data')).data,
			subBoss:[],
			subBossId:'',
			addBoss:[],
			addObj:{},
			caseId:'',
			accountLevel:JSON.parse(window.localStorage.getItem('accountLevel')).data,
		};
	},
	methods: {
		setTxt(str, status) {
			if (constants.setTxt(str, status)) {
				return constants.setTxt(str, status);
			} else {
				return str;
			}
		},
		setTime(str) {
			return constants.time(str);
		},
		setPt(str) {
			return constants.pt2txt3(str);
		},
		getData() {
			var data = {
				token: this.token,
				start: 0,
				count: 200
			};
			listUnassignedCase(data)
			.then(res => {
				console.log(res);
				this.tableData = res.data.obj;
			})
			.catch(err => {
				console.log(err);
			});
			listSubUser(data)
			.then(res => {
				this.subBoss = res.data.obj;
			})
			.catch(err => {
				console.log(err);
			});
		},
		addBossFun(){
			if(this.addObj.id == undefined) return this.$message.warning('不能为空！')
			if(this.addBoss.length == 0) return this.addBoss.push(this.addObj)
			var btn =true;
			this.addBoss.forEach(item =>{
				if(item.id == this.addObj.id){
					this.$message.warning('已存在，请不要重复添加！')
					btn=false
				}
			})
			if(btn) this.addBoss.push(this.addObj)
			console.log(this.addBoss)
		},
		changeBossFun(id){
			this.addObj=this.subBoss.find(item =>{
				return item.id == id
			})
		},
		deleteObj(index){
			this.addBoss.splice(index,1)
		},
		submitBoss(){
			if(this.addBoss.length == 0) return this.$message.warning('请选择需要分配的公司！')
			var id=''
			this.addBoss.forEach(item => {
				id += item.id+','
			})
			var data = {
				token: this.token,
				caseId: this.caseId,
				opSids: id
			};
			assignSubRegulator(data)
			.then(res => {
				if(res.data.code == 0){
					this.$message.success('分配成功！')
					this.addBoss='';
					this.dialogVisible=false
				}else{
					this.$message.warning(res.data.msg)
				}
			})
			.catch(err => {
				console.log(err);
			});
		}
	},
	mounted() {
		this.getData();
	}
};
</script>
<style scoped="scoped">
	.addBoss{width: 300px;margin-top: 30px;}
	.addBoss li{overflow: hidden;line-height: 40px;}
	.addBoss li p{float: left;}
	.addBoss li i{float: right;margin-top: 5px;font-size: 20px;cursor: pointer;}
	.h2{    font-size: 20px;
    color: #333;
    font-weight: normal;
    margin-bottom: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/regulator/undistributed.vue